import { render, staticRenderFns } from "./Files.vue?vue&type=template&id=497ea6b4"
import script from "./Files.vue?vue&type=script&lang=ts"
export * from "./Files.vue?vue&type=script&lang=ts"
import style0 from "./Files.vue?vue&type=style&index=0&id=497ea6b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports